var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppAdobeExpress({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2648 0H9.73519C4.35859 0 0 4.35859 0 9.73519V44.2648C0 49.6414 4.35859 54 9.73519 54H44.2648C49.6414 54 54 49.6414 54 44.2648V9.73519C54 4.35859 49.6414 0 44.2648 0Z",
    fill: "#000B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4495 15.953C31.4365 13.558 29.0915 12 26.4885 12C23.8855 12 21.5175 13.562 20.5065 15.965L12.3215 35.458C11.1995 38.121 13.1525 41.066 16.0415 41.066H25.1565C27.3945 41.061 29.2065 39.245 29.2065 37.004C29.2065 34.763 27.3885 32.942 25.1445 32.942C25.0525 32.942 23.5865 32.954 23.5865 32.954C22.9265 32.954 22.4815 32.282 22.7375 31.673L25.6425 24.75C25.9585 23.998 26.9905 23.993 27.3085 24.745L33.2365 38.605C34.0505 40.455 35.6005 41.059 36.9655 41.063C39.8615 41.063 41.8135 38.114 40.6855 35.448L32.4495 15.953Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21_131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 30,
    height: 30
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4495 15.953C31.4365 13.558 29.0915 12 26.4885 12C23.8855 12 21.5175 13.562 20.5065 15.965L12.3215 35.458C11.1995 38.121 13.1525 41.066 16.0415 41.066H25.1565C27.3945 41.061 29.2065 39.245 29.2065 37.004C29.2065 34.763 27.3885 32.942 25.1445 32.942C25.0525 32.942 23.5865 32.954 23.5865 32.954C22.9265 32.954 22.4815 32.282 22.7375 31.673L25.6425 24.75C25.9585 23.998 26.9905 23.993 27.3085 24.745L33.2365 38.605C34.0505 40.455 35.6005 41.059 36.9655 41.063C39.8615 41.063 41.8135 38.114 40.6855 35.448L32.4495 15.953Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21_131)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 30,
    height: 30,
    fill: "#FFFEFE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 37.5,
    r: 18.5,
    fill: "url(#paint0_radial_21_131)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 39.5,
    r: 18.5,
    fill: "url(#paint1_radial_21_131)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 37.5,
    r: 9.5,
    fill: "url(#paint2_radial_21_131)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 14.5,
    r: 20.5,
    fill: "url(#paint3_radial_21_131)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 22.5,
    r: 11.5,
    fill: "url(#paint4_radial_21_131)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 14,
    r: 10,
    fill: "url(#paint5_radial_21_131)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 16,
    r: 10,
    fill: "url(#paint6_radial_21_131)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 25.5,
    r: 10.5,
    fill: "url(#paint7_radial_21_131)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 31.5,
    r: 10.5,
    fill: "url(#paint8_radial_21_131)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 30.5,
    r: 6.5,
    fill: "url(#paint9_radial_21_131)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_21_131",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.5 37.5) rotate(90) scale(18.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3084FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3084FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_21_131",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.5 39.5) rotate(90) scale(18.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3084FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3084FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_21_131",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.5 37.5) rotate(90) scale(9.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CE342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#6CE342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CE342",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_21_131",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5 14.5) rotate(90) scale(20.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F20A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F20A00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_21_131",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.5 22.5) rotate(90) scale(11.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF43E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF43E3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_21_131",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23 14) rotate(90) scale(10)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F20A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F20A00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_21_131",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30 16) rotate(90) scale(10)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE3E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE3E00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_21_131",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.5 25.5) rotate(90) scale(10.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC800",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_21_131",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5 31.5) rotate(90) scale(10.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E059FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E059FD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_21_131",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.5 30.5) rotate(90) scale(6.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E30A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF6E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppAdobeExpress);
export default __webpack_public_path__ + "static/media/B_app_AdobeExpress.efb3ce2e3970e86e0c6fcf8771e56422.svg";
export { ForwardRef as ReactComponent };